
import React from 'react';
import PropTypes from 'prop-types';
import { X, FileText, Image } from 'lucide-react';
import { formatFileSize } from './utils/AiUtils';
import styles from './FilePreview.module.scss';

const getFileIcon = (fileType) => {
  if (fileType.startsWith('image/')) {
    return <Image size={16} />;
  }
  return <FileText size={16} />;
};

const FilePreview = ({ attachedFiles, onRemoveFile }) => {
  if (attachedFiles.length === 0) {
    return null;
  }

  return (
    <div className={styles.filePreview}>
      <div className={styles.filePreviewTitle}>
        Attached Files ({attachedFiles.length}):
      </div>
      {attachedFiles.map(fileData => (
        <div key={fileData.id} className={styles.filePreviewItem}>
          <div className={styles.filePreviewContent}>
            <span className={styles.fileIcon}>
              {getFileIcon(fileData.type)}
            </span>
            <span className={styles.fileName}>
              {fileData.name}
            </span>
            <span className={styles.fileSize}>
              ({formatFileSize(fileData.size)})
            </span>
          </div>
          <button
            onClick={() => onRemoveFile(fileData.id)}
            className={styles.removeFileButton}
            title="Remove file"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};

FilePreview.propTypes = {
  attachedFiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      file: PropTypes.object.isRequired
    })
  ).isRequired,
  onRemoveFile: PropTypes.func.isRequired
};

export default FilePreview;